import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { DropzoneOptions } from 'react-dropzone';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { MarginProps } from '../../../../../theme/styledProps';
import { Grid } from '../../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import Column from '../../../../../CommonComponents/Column';
import { toast } from '../../../../../CommonComponents/OPL/Toast/Toast';
import { Loading } from '../../../../../CommonComponents/OPL/Loading/Loading';
import { Dropzone } from '../../../../../CommonComponents/OPL/Dropzone/Dropzone';
import { Avatar } from './components/Avatar/Avatar';
import { useUploadAvatarMutation } from '../../api/useUploadAvatarMutation';
import { ContactInfoForm } from './components/ContactInfoForm/ContactInfoForm';
import { AVATAR_CONTAINER_HEIGHT } from './ContactInfo.meta';
import { FormValues } from '../../MySettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const ContactInfo: React.FC<Props> = ({ formBag, ...rest }) => {
  const { mutateAsync: uploadAvatar, isLoading: isUploadingAvatar } = useUploadAvatarMutation();

  const avatarFilename = formBag.watch('adviserImageFilename');

  const dropZoneOptions: DropzoneOptions = {
    noClick: true,
    accept: 'image/*',
    multiple: false,
    onDropAccepted: async ([file]) => {
      try {
        const fileName = await uploadAvatar({ file });

        formBag.setValue('adviserImageFilename', fileName, { shouldDirty: true });
      } catch (err) {
        if (err instanceof Error) {
          toast.error(err.message);
        }
      }
    },
    onDropRejected() {
      toast.error('Unsupported file type.');
    },
  };

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Contact Information" />

      <Grid>
        <Row>
          <Column width={5}>
            <Controller
              control={formBag.control}
              name="adviserImageFilename"
              render={() =>
                isUploadingAvatar ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height={AVATAR_CONTAINER_HEIGHT}
                  >
                    <Loading text="Uploading..." />
                  </Box>
                ) : avatarFilename ? (
                  <Avatar
                    avatarFilename={avatarFilename}
                    dropZoneOptions={dropZoneOptions}
                    formBag={formBag}
                  />
                ) : (
                  <Dropzone options={dropZoneOptions} />
                )
              }
            />
          </Column>

          <Column width={7}>
            <ContactInfoForm formBag={formBag} />
          </Column>
        </Row>
      </Grid>
    </Box>
  );
};
